import React, { Component } from 'react';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/SaveRounded';
import AddIcon from '@mui/icons-material/Add';
import SaleStore from './SaleStore';
import './sales.css'
import WorkLink from '../Kanban/WorkLink';
import WorkStore from '../Kanban/WorkStore';
import LinearProgress from '@mui/material/LinearProgress';
import MaterialTable from '@material-table/core';
import { observer } from 'mobx-react';
import AuthStore from '../../Auth/AuthStore';

const SaleWorks = observer(class SaleWorks extends Component {

    columns = [
        { title: 'Задача', field: 'id', render: w => <WorkLink workId={w.id} name={w.caption} number={w.number} /> },
        { title: 'Заголовок', field: 'caption' },
        { title: 'Ответственный', field: 'assignee' },
        { title: 'Тестировщик', field: 'tester' },
        { title: 'Состояние', field: 'status' },
        { title: 'Потрачено', field: 'factTotal' },
    ];

    constructor(props) {
        super(props);

        this.state = {
            works: [],
            times: []
        };

        this.loadWorks = this.loadWorks.bind(this);
        this.handleWorkAdd = this.handleWorkAdd.bind(this);
        this.loadTimes = this.loadTimes.bind(this);
    }

    componentDidMount() {
        this.loadWorks();
        this.loadTimes();
    }

    loadWorks() {
        var scope = this;
        var token = localStorage.getItem("token");
        var addr = this.props.isInvoice ? 'api/Work/GetInvoiceWorks?invoiceId=' : 'api/Work/GetSaleWorks?saleId=';
        fetch(addr + this.props.saleId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ works: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    loadTimes() {
        var scope = this;
        var token = localStorage.getItem("token");
        var addr = this.props.isInvoice ? 'api/Invoice/GetInvoiceWorksTimeDistribution?invoiceId=' : 'api/Sale/GetSaleWorksTimeDistribution?saleId=';
        fetch(addr + this.props.saleId, {
            method: 'GET',
            body: null,
            headers: {
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (res.status === 401) {
            }
            else {
                res.json().then((result) => {
                    scope.setState({ times: result });
                }).catch((err) => console.log(err));
            }
        });
    }

    handleWorkAdd() {
        var scope = this;
        var work = this.props.isInvoice ?
            {
                invoiceId: this.props.saleId,
                invoiceNumber: this.props.saleNumber,
                assignee: AuthStore.getUser.fullName,
                assigneeRoleId: AuthStore.getUser.roleId,
                assigneeId: AuthStore.getUserId,
                account: SaleStore.getInvoice.account,
                accountId: SaleStore.getInvoice.accountId
            } :
            {
                saleId: this.props.saleId,
                saleNumber: this.props.saleNumber,
                assignee: AuthStore.getUser.fullName,
                assigneeRoleId: AuthStore.getUser.roleId,
                assigneeId: AuthStore.getUserId,
                account: SaleStore.getSale.account,
                accountId: SaleStore.getSale.accountId
            };
        WorkStore.openWorkDialog(work, (w) => {
            var works = scope.state.works.slice(0);
            works.push(w);
            scope.setState({ works: works });
        });
    }

    render() {

        //var works = this.state.works.map(w => <div className="sale-work-list-item"><WorkLink workId={w.id} name={w.caption} number={w.number} />{w.caption} <b>&nbsp;Потрачено: {w.factHours.toFixed(1)} часов</b></div>);
        var totalHours = this.state.times.reduce((a, b) => { return a + b.hours; }, 0);
        return (
            <div>
                <IconButton onClick={this.handleWorkAdd} size="large">
                    <AddIcon />
                </IconButton>

                {this.state.times.map(u => <div key={u.userName}>
                    {u.userName}
                    <LinearProgress color="primary" variant="determinate" value={100 * u.hours / totalHours} />
                    {u.hours.toFixed(1)}ч
                </div>)}

                <MaterialTable
                    title=""
                    columns={this.columns}

                    data={this.state.works}
                    editable={{
                    }}
                    actions={[
                    ]}
                />
            </div>
        );
    }
});

export default SaleWorks;